import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { MigrationsManagerApi } from './migrationsManagerApi';
import { MigrationsManagerApiKey } from './publicApiKey';
import { MigrationsManagerStore } from './store';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  store = this.declareStore(MigrationsManagerStore);
}

export const MigrationsManagerEntryPoint = createEntryPoint({
  name: 'MigrationsManagerEntryPoint',
  publicApi({ contributeApi }) {
    contributeApi(MigrationsManagerApiKey, MigrationsManagerApi);
  },
  Scope,
  async initialize() {},
});
